import { render, staticRenderFns } from "./BbeeCalidadACCRM.vue?vue&type=template&id=2b9fec54"
import script from "./BbeeCalidadACCRM.vue?vue&type=script&lang=js"
export * from "./BbeeCalidadACCRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports